export type SpaceSource = {
	ari: string;
	url: string;
	// `sourceType` is intentionally widened to `string` (rather than the
	// `SpaceSourceType` enum) because consumers like `homeThreadsService` derive
	// it dynamically from URL/typename heuristics and use values such as
	// 'confluence', 'jira', 'bitbucket', 'loom', 'github', 'web', 'unknown'
	// that are not part of the BE enum.
	sourceType: string;
	conversationIds: string[];
	name?: string;
};

/**
 * Form-only extension of `SpaceSource`. `displayText` is stripped before
 * any BE call or `onCreate` callback — use `toSpaceSource` at submission time.
 */
export type SpaceSourceFormValue = SpaceSource & {
	/**
	 * User-provided override for the displayed source name. When set and
	 * non-empty, this takes precedence over the SmartLink-resolved title in
	 * the UI but is never sent to the BE.
	 */
	displayText?: string;
};

/**
 * Strip client-only form fields (e.g. `displayText`) from a form-shaped
 * source so it is safe to hand to BE callers.
 */
export const toSpaceSource = ({
	displayText: _displayText,
	...rest
}: SpaceSourceFormValue): SpaceSource => rest;
